import React from 'react';
import { Link } from 'react-router-dom';
import PortalGatewayPage from './PortalGatewayPage';
import { Button } from '@/components/ui/button';

/**
 * Dev preview — portal gateway + links to dedicated logins.
 */
export default function PortalPreviewPage() {
  return (
    <div className="min-h-dvh bg-[#030810]">
      <div className="border-b border-[#C9A84C]/20 bg-[#0a1628]/95 px-4 py-3 text-center backdrop-blur-md">
        <p className="text-xs font-bold uppercase tracking-wider text-[#C9A84C]">Preview — separate portals</p>
        <div className="mt-2 flex flex-wrap justify-center gap-2">
          <Button asChild size="sm" variant="outline" className="border-[#C9A84C]/35 text-[#E8D5A3]">
            <Link to="/login/client">Client login</Link>
          </Button>
          <Button asChild size="sm" variant="outline" className="border-[#C9A84C]/35 text-[#E8D5A3]">
            <Link to="/login/owner">Owner login</Link>
          </Button>
          <Button asChild size="sm" variant="outline" className="border-[#C9A84C]/35 text-[#E8D5A3]">
            <Link to="/register/client">Client register</Link>
          </Button>
          <Button asChild size="sm" className="bg-[#C9A84C] text-[#0a1628]">
            <Link to="/login">Live gateway</Link>
          </Button>
        </div>
      </div>
      <PortalGatewayPage />
    </div>
  );
}
